import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { msalInstance } from './config/msalConfig'
import { trackActiveAccount } from './config/activeAccount'
import App from './App'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

// Initialize MSAL before rendering
msalInstance.initialize().then(async () => {
  // Every later sign-in or token result marks its account active (see config/activeAccount).
  trackActiveAccount(msalInstance)
  // Finish a sign-in redirect BEFORE the first render, so the first API call already knows
  // which account the user signed in with rather than taking whichever is cached first.
  try {
    const result = await msalInstance.handleRedirectPromise()
    if (result?.account) msalInstance.setActiveAccount(result.account)
  } catch (err) {
    console.error(err)
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </MsalProvider>
    </React.StrictMode>
  )
})
